import { ComponentInfo } from "@builder.io/sdk-react";

export const CATEGORY_ITEMS_INPUTS = [
  {
    name: "items",
    type: "list",
    subFields: [
      {
        name: "name",
        type: "string",
        defaultValue: "",
      },
      {
        name: "url_key",
        type: "string",
        defaultValue: "",
      },
      {
        name: "sku",
        type: "string",
        defaultValue: "ploom",
      },
      {
        name: "shortDescription",
        type: "string",
      },
      {
        name: "isNew",
        type: "boolean",
      },
      {
        name: "thumbnailSrc",
        type: "string",
        defaultValue: "",
        required: false,
      },
    ],
    defaultValue: [],
  },
  {
    name: "columnDesktopWidth",
    type: "string",
    enum: ["3", "4", "6", "12"],
    defaultValue: "4",
    required: true,
  },
  {
    name: "columnTabletWidth",
    type: "string",
    enum: ["3", "4", "6", "12"],
  },
] as const satisfies ComponentInfo["inputs"];

export type CategoryItemsProps = BuilderComponentProps<
  typeof CATEGORY_ITEMS_INPUTS
>;
